<template>
  <ExternalQueryList
      endpoint="/api/v2/retention-touchpoints"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="retentionTouchpoint => $router.push(getUrl(retentionTouchpoint))"
  >
    <template v-slot:default="{ row: retentionTouchpoint }">
      <td>
        <router-link :to="getUrl(retentionTouchpoint)">
          {{ retentionTouchpoint.attributes.name }}
        </router-link>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  computed: {
    headlines() {
      return [
        {width: 22, text: 'Name'}
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(retentionTouchpoint) {
      return '/retention-touchpoints/' + retentionTouchpoint.id + '/edit'
    }
  }
}
</script>
